import React from "react";
import Footer from "../../components/general components/Footer";
import Header from "../../components/general components/Header";
import { motion, AnimatePresence } from "framer-motion";
import ProfilePhoto from "../../assets/images/perfil.jpg";
import * as C from "./styles";

const AboutMe = () => {
  return (
    <C.Container>
      <Header />
      <C.Presentation>
        <AnimatePresence>
          <motion.div
            initial={{ y: -300, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 300, opacity: 0 }}
            transition={{ duration: 1.5 }}
          >
            <C.DivInformation>
              <img
                src={ProfilePhoto}
                alt="Foto de Perfil"
                className="profilePhoto"
              />
              <h1>Gabriel Oliveira Santos</h1>
              <p>19 Anos</p>
              <h5>Analista de Sistemas</h5>
              <hr />
            </C.DivInformation>
          </motion.div>
        </AnimatePresence>
      </C.Presentation>

      <C.DivAboutMe>
        <h1>Sobre Mim</h1>
        <AnimatePresence>
          <motion.div
            initial={{ y: 300, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -300, opacity: 0 }}
            transition={{ duration: 1.5 }}
          >
            <p>
              Começei no mundo da tecnologia com 16 anos em um curso Técnico em
              Desenvolvimento de Sistemas, desde então, logo após esse curso,
              não parei mais de melhorar minhas skills e a cada dia que passa,
              venho adquirindo mais conhecimento na área do Desenvolvimento. De
              lá para cá, foram diversos cursos voltados para área tecnológica
              como também iniciação na graduação em Ciências da Computação. Sou
              uma pessoa focada e que busca desafios, sempre analisando
              problemas com calma, e sendo assim, tendo o objetivo de progredir
              cada vez nessa área que eu tanto amo.
            </p>
          </motion.div>
        </AnimatePresence>
      </C.DivAboutMe>

      <C.DivAboutMe>
        <h1>Meus Hobbies</h1>
        <AnimatePresence>
          <motion.div
            initial={{ y: 300, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -300, opacity: 0 }}
            transition={{ duration: 1.5 }}
          >
            <p>
              Apesar de programação ser um dos meus hobbies favoritos, não posso
              deixar de citar outras coisas que me fazem acordar todos os dias.
              Exemplos disso são sair com os amigos, assisir filmes e séries,
              viajar, jogar futebol ou também ver uma partida no estádio, ler
              bastente sobre tech ou ficção científica, meditar entre muitas
              outras coisas.
            </p>
          </motion.div>
        </AnimatePresence>
      </C.DivAboutMe>
      <Footer />
    </C.Container>
  );
};

export default AboutMe;
